import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageProvider';
import RegistrationWizard from './RegistrationWizard';

const RegistrationModal = ({ isOpen, onClose, triggerRef }) => {
  const { t } = useLanguage();
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    const triggerElement = triggerRef?.current;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusableElements = dialogRef.current?.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href]',
      );
      if (!focusableElements?.length) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
      triggerElement?.focus();
    };
  }, [isOpen, onClose, triggerRef]);

  if (!isOpen) return null;

  return (
    <div
      className="ws-registration-modal"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="ws-registration-modal__dialog"
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="ws-registration-modal-title"
      >
        <div className="ws-registration-modal__header">
          <div>
            <span className="ws-kicker">{t('Inscription Business')}</span>
            <h2 id="ws-registration-modal-title">{t('Inscrire votre business')}</h2>
          </div>
          <button
            className="ws-registration-modal__close"
            type="button"
            onClick={onClose}
            aria-label={t('Fermer le formulaire d’inscription')}
          >
            <X size={24} aria-hidden="true" />
          </button>
        </div>
        <RegistrationWizard />
      </div>
    </div>
  );
};

export default RegistrationModal;
